import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import ContactBanner from './contact-banner';
import ContactForm from './contact-form'; 
import ContactLocation from './contact-location';

function ContactPage () {
    return(
      <Fragment> 
      <Header />  
      <ContactBanner /> 
      <ContactForm /> 
      <ContactLocation />
      <Footer /> 
      </Fragment> 
    );
}
export default ContactPage;